import React from 'react';
import Can from "../Can";
import LabInventoryPage from './LabInventoryPage';

function LabInventory(props) {
    var myHome;

    if (!props.apiAuthGroups) {
        myHome = (
            <React.Fragment>
                <h2>Non autorizzato</h2>
            </React.Fragment>
        )
    } else {
        myHome = (
            <Can
                role={props.apiAuthGroups}
                perform="labExamRequest-page:visit"
                yes={() => (
                    <LabInventoryPage
                        apiAuthResponse={props.apiAuthResponse}
                        apiAuthName={props.apiAuthName}
                        apiAuthSurname={props.apiAuthSurname}
                        apiAuthGroups={props.apiAuthGroups}
                    />

                )}
                no={() => null}
            />
        )
    }


    return myHome;
}

export default LabInventory;